import styled from 'styled-components'
import tw from 'tailwind-styled-components'

interface WrapperProps {
  $color?: string
  $disabled?: boolean
  $isOverlay?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  width: 350px;
  height: 176px;
  display: flex;
  flex-direction: column;
  position: relative;

  .bg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 95%;
    height: auto;
    transform: translateX(-50%) translateY(-50%);
    filter: ${({ $disabled, $isOverlay }) => ($disabled && !$isOverlay ? 'grayscale(100%)' : 'none')};
  }

  svg.borderSvg {
    fill: ${(props) => props.$color || '#000'};
    color: ${(props) => props.$color || '#000'};
    position: absolute;
    top: -4px;
    left: -2px;

    .solid-path {
      fill: ${(props) => props.$color || '#000'};
      transition: opacity 0.1s ease-in-out;
      opacity: 1;
    }

    .gradient-path {
      fill: url(#paint6_linear_194_487);
      transition: opacity 0.1s ease-in-out;
      opacity: 0;
    }
  }

  .bounty-title-wrapper,
  .bounty-footer-wrapper,
  .bounty-header-wrapper {
    z-index: 101;
  }

  ${({ $disabled }) =>
    !$disabled &&
    `
      &:hover {
        svg.borderSvg {
          .solid-path {
            opacity: 0;
          }
          .gradient-path {
            opacity: 1;
          }
        }
      }
  `}

  ${({ $isOverlay }) =>
    $isOverlay &&
    `
      &:hover {
        .bounty-title-wrapper,
        .bounty-footer-wrapper,
        .bounty-header-wrapper {
          display: none;
        }

        .grabbed-wrapper {
          display: flex;
           opacity: 1;
        }
      }
  `}
`
export const GrabbedWrapper = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 22px 22px 0 20px;
`

export const FooterWrap = styled.div`
  bottom: 16px;
  position: absolute;
  width: 100%;
  justify-content: center;
  display: flex;
  z-index: 101;
  text-transform: uppercase;
`

export const InfoIconWrapper = styled.div`
  z-index: 101;
  margin-top: -6px;
  min-width: 27px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: all 0.3s ease-in-out;
    transform: scale(1);

    &:hover {
      filter: drop-shadow(0 0 4px rgba(243, 12, 109, 0.6));
      transform: scale(1.05);
    }
  }
`

export const SubtitleContainer = tw.div`
  text-yellow text-2xl font-extrabold text-center leading-6 pt-3
  ${(p: { disabled?: boolean }) => (p.disabled ? 'filter grayscale' : '')}
`

interface BountyTitleProps {
  $disabled?: boolean
}
export const CountdownTimerWrapper = styled.div<BountyTitleProps>`
  width: 314px;
  font-size: 9px;
  text-align: center;
  font-weight: 700;
  opacity: 0.8;
  color: ${(props) => (props.$disabled ? '#f30c6d' : 'white')};
  background-color: ${(props) => (props.$disabled ? 'white' : '')};
`

export const BountyCountWrapper = styled.div`
  width: 20px;
  position: relative;
`

export const BountyCountStyled = tw.div`
  absolute right-0 w-max absolute text-xs text-yellow font-bold
`

export const BountyTitle = styled.h4<BountyTitleProps>`
  position: relative;
  text-align: center;
  margin-bottom: ${({ $disabled }) => ($disabled ? '0' : '5px')};
  font-size: 0.875rem;
  font-weight: 800;
  width: 270px;
  text-align: center;
  text-transform: uppercase;
  color: white;

  ${({ $disabled }) =>
    !$disabled &&
    `
    &:after {
      position: absolute;
      content: '';
      width: 20%;
      height: 2px;
      background-color: white;
      bottom: -2px;
      left: 41%;
    }
  `}
`

export const GrabbedTitleStyled = styled.h4`
  position: relative;
  text-align: center;
`

export const GrabbedTitle = tw(GrabbedTitleStyled)`
  text-sm font-extrabold w-270 text-center uppercase text-white
`

export const InputWrapper = styled.div`
  margin-top: 5px;
  font-family: 'Courier New', monospace;

  input {
    color: #3ccea2;
    border: 1px solid #525252;
    text-transform: uppercase;
  }
`
